<template>
  <svg aria-hidden="true" v-on="$listeners" :class="svgClass">
    <use :xlink:href="iconId" />
  </svg>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue-demi';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    iconName: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  setup(prop) {
    const iconId = computed(() => `#icon-${prop.iconName}`);
    const svgClass = computed(() => {
      if (prop.className) {
        return `svg-icon ${prop.className}`;
      }
      return 'svg-icon';
    });
    const styleExternalIcon = computed(() => ({
      mask: `url(${prop.iconName}) no-repeat 50% 50%`,
      '-webkit-mask': `url(${prop.iconName}) no-repeat 50% 50%`,
    }));
    return {
      iconId,
      svgClass,
      styleExternalIcon,
    };
  },
});
</script>
